// PAYLOAD_DATE_FORMAT is the format of the date for creating items
export const PAYLOAD_DATE_FORMAT = 'YYYY-MM-DD';

export const ITEM_TYPE_OFFER = 'offer';
export const ITEM_TYPE_GIFT_CARD = 'gift_card';
export const ITEM_TYPE_INSURANCE = 'insurance';
export const ITEM_TYPE_ADDON = 'addon';
export const ITEM_TYPE_EXPERIENCE = 'experience';
export const ITEM_TYPE_FLIGHT = 'flight';
export const ITEM_TYPE_OFFLINE_FLIGHT = 'offline_flight';
export const ITEM_TYPE_TOUR = 'tour';
export const ITEM_TYPE_CRUISE = 'cruise';
export const ITEM_TYPE_CAR_HIRE = 'car_hire';
export const ITEM_TYPE_SERVICE_FEE = 'service_fee';
export const ITEM_TYPE_SUBSCRIPTION = 'subscription';
export const ITEM_TYPE_BEDBANK = 'bedbank';
export const ITEM_TYPE_MERCHANDISE = 'merchandise';
export const ITEM_TYPE_LOYALTY_POINTS = 'loyalty_points';

export const EDIT_ORDER_TITLE = 'Edit Order';
export const PATCH_REPLACE_ORDER = 'replace';
export const PATCH_UPDATE_FRAUD_STATUS = 'update_order_fraud_status';
export const ADD_NOTE = 'Add new note';

export const UPDATE_ORDER_GIFT = 'Update Gift';

export const ITEM_STATUS_CANCELLED = 'cancelled';
export const ITEM_STATUS_COMPLETED = 'completed';
export const ITEM_STATUS_FAILED = 'failed';

export const ORDER_STATUS_COMPLETED = 'completed';
export const ORDER_STATUS_CANCELLED = 'cancelled';
export const ORDER_STATUS_PENDING = 'pending';
export const ORDER_STATUS_ABANDONED = 'abandoned';
export const ORDER_STATUS_FAILED = 'failed';
export const ORDER_STATUS_DECLINED = 'declined';

// Display labels for all possible order statuses
export const ORDER_STATUS_LABELS: Record<string, string> = {
  awaiting_purchase: 'Awaiting Purchase',
  processing: 'Processing',
  pending: 'Pending',
  awaiting_payment: 'Awaiting Payment',
  completed: 'Completed',
  abandoned: 'Abandoned',
  cancelled: 'Cancelled',
  payment_failed: 'Payment Failed',
  payments_created: 'Payments Created',
  failed: 'Failed',
};

// Order status options available for admin status change dropdown
export const ORDER_STATUS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: ORDER_STATUS_PENDING, label: 'Pending' },
  { value: ORDER_STATUS_COMPLETED, label: 'Completed' },
  { value: ORDER_STATUS_CANCELLED, label: 'Cancelled' },
];

export const OPERATION_UPDATE_ORDER_CUSTOM_ITEM = 'update_order_custom_item';
export const OPERATION_REBOOK_AS_CUSTOM_OFFER = 'rebook_as_custom_offer';
export const OPERATION_CANCEL_CUSTOM_ORDER_ADMIN = 'cancel_custom_order_admin';
export const OPERATION_SET_INSURANCE_CLAIM_ADMIN = 'set_insurance_claim_admin';
export const OPERATION_RESOLVE_ROOM_MAPPING_WITH_CUSTOMER = 'resolve_room_mapping_with_customer';

export enum OrderPatchOperations {
  PATCH_REPLACE_ORDER = 'replace',
  PATCH_UPDATE_FRAUD_STATUS = 'update_order_fraud_status',
  PATCH_MANUAL_COMPLETE_ORDER = 'manual_complete_order',
  PATCH_MANUAL_CANCEL_ORDER = 'manual_cancel_order',
}

// Fraud Status Constants using the existing FraudStatus type
export const FRAUD_STATUS: Record<string, App.FraudStatus> = {
  // Auto statuses (system generated - read-only)
  AUTO_FLAGGED_FOR_REVIEW: 'auto_flagged_for_review',
  AUTO_REVIEWED_FRAUD: 'auto_reviewed_fraud',
  AUTO_REVIEWED_NOT_FRAUD: 'auto_reviewed_not_fraud',

  // Manual statuses (user selectable)
  MANUAL_FLAGGED_FOR_REVIEW: 'manual_flagged_for_review',
  MANUAL_REVIEWED_FRAUD: 'manual_reviewed_fraud',
  MANUAL_REVIEWED_NOT_FRAUD: 'manual_reviewed_not_fraud',
} as const;

// Manual fraud status options available for user selection
export const MANUAL_FRAUD_STATUS_OPTIONS: Array<{ value: App.FraudStatus; label: string }> = [
  { value: FRAUD_STATUS.MANUAL_FLAGGED_FOR_REVIEW, label: 'Pending Review' },
  { value: FRAUD_STATUS.MANUAL_REVIEWED_NOT_FRAUD, label: 'Reviewed Not Fraud' },
  { value: FRAUD_STATUS.MANUAL_REVIEWED_FRAUD, label: 'Reviewed Fraud' },
];

export const ORDER_NOTIFICATION_TYPE_BOOKING_CONFIRMATION_V4 = 'booking_confirmation_v4';

// TODO: Replace with type from @luxuryescapes/contract-svc-order once available.
export type OrderEditLogField = 'fraud_status' | 'utm_medium' | 'fk_purchaser_id' | 'status';

export const ORDER_EDIT_LOG_FIELD_LABELS: Record<OrderEditLogField, string> = {
  fraud_status: 'Fraud Status',
  utm_medium: 'UTM Medium',
  fk_purchaser_id: 'Sold By',
  status: 'Order Status',
};

// Display labels for all fraud statuses (including auto)
export const FRAUD_STATUS_LABELS: Partial<Record<App.FraudStatus, string>> = {
  auto_flagged_for_review: 'Auto Flagged for Review',
  auto_reviewed_fraud: 'Auto Reviewed Fraud',
  auto_reviewed_not_fraud: 'Auto Reviewed Not Fraud',
  manual_flagged_for_review: 'Pending Review',
  manual_reviewed_fraud: 'Reviewed Fraud',
  manual_reviewed_not_fraud: 'Reviewed Not Fraud',
};
